import Component from '@bythepixel/component-loader';
import DEFAULTS from '@Components/cardFiltering/_config';

export default class CardFiltering extends Component {
  static selector = DEFAULTS.selectors.container;

  constructor(containerEl, options = DEFAULTS) {
    super(containerEl, options);

    if (!this.$container) {
      return;
    }

    this.cssClasses = this.$options.cssClasses;
    this.selectors = this.$options.selectors;

    this.categoryGroupsEl = this.$container.querySelector(this.selectors.categoryGroups);
    this.categoryGroups = this.categoryGroupsEl ? JSON.parse(this.categoryGroupsEl.dataset.compCardFilteringCategories) : '';

    this.checkboxes = this.$container.querySelectorAll(this.selectors.checkbox);
    this.cards = this.$container.querySelectorAll(this.selectors.card);

    this.pageLoadEvents();
    this.initializeListeners();
  }

  getCheckboxes() {
    return this.checkboxes;
  }

  getSelectedFilters() {
    const filters = [];

    const checkedBoxes = this.$container.querySelectorAll('input[type="checkbox"]:checked');
    checkedBoxes.forEach(box => {
      filters.push(box.id);
    });

    return filters;
  }

  initializeListeners() {
    this.checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', () => this.toggleVisibility());
    });
  }

  pageLoadEvents() {
    this.toggleVisibility();
  }

  toggleVisibility(cards = []) {
    const filters = this.getSelectedFilters();

    if (cards.length > 0) {
      this.cards = cards;
    }

    this.cards.forEach(card => {
      const { dataset } = card;
      // Remove this attribute, not needed for this purpose
      delete dataset.compGenericCard;

      const hideCard = Object.entries(dataset).some(data => {
        const value = data[1];
        return !filters.includes(value);
      });

      card.classList.toggle(this.cssClasses.hiddenCard, hideCard);
    });
  }
}
